export const LicensesTemplate = (_owner, _receiver, _durationDays) => {
  // Purpose of this template: create a JSON license contract

  const today = new Date();
  var endDate = new Date();
  endDate.setDate(today.getDate() + _durationDays);

  // Initiate an empty JavaScript Object
  const copyrightLicenseAgreement = {
    Title: "",
    Owner: _owner,
    Receiver: _receiver,
    Start_Date: today,
    Termination_Date: endDate,
    Duration_Days: _durationDays,
    Purpose: "",
    Grant_Of_License: "",
    Rights_and_Obligations: "",
    Payment_Of_Royalty: "",
    Modifications: "",
    Deafults: "",
    Arbitration: "",
    Warranties: "",
    Transfer_Of_Rights: "",
    Indemnification: "",
    Termination: "",
    Entire_Agreement: "",
    Amendment: "",
    Severability: "",
    Notice: "",
    Applicable_Law: "",
    Signatories: "",
  };

  // Template literals are literals delimited with backticks (``),
  // allowing embedded expressions called substitutions, i.e. easy integration of variables via placeholders, e.g. ${expression}
  // "+" operator is used to concatenate strings

  // Fill in values of the JavaScript Object
  copyrightLicenseAgreement.Title = `Illustrative(e.g. sample) Copyright Contract`;

  copyrightLicenseAgreement.Purpose = `This contract is for illustrative purposes only. It is not binding and should be used as an illustration`;

  copyrightLicenseAgreement.Grant_Of_License =
    `${_owner} owns [Insert Copyright Being Licensed] (“[Insert Shortname of Copyright Being Licensed]”). ` +
    `In accordance with this Agreement, ${_owner} grants ${_receiver} an exclusive license to use the [Insert Shortname of Copyright Being Licensed]. ` +
    `${_owner} retains title and ownership of the [Insert Shortname of Copyright Being Licensed]. ` +
    `${_receiver} will own all rights to materials, products, or other works (the Work) created by ${_receiver} in connection with this license. ` +
    `This grant of the license only applies to the following described geographical area: [Insert Geographical License Area]`;

  copyrightLicenseAgreement.Rights_and_Obligations =
    `${_receiver} shall be solely responsible for providing all funding and technical expertise for the development and marketing of the Work in which the licensed property is used. ` +
    `${_receiver} shall be the sole owner of the Work and all proprietary rights in and to the Work; ` +
    `except, such ownership shall not include ownership of the copyright in and to the [Insert Shortname of Copyright Being Licensed] or any other rights to the [Insert Shortname of Copyright Being Licensed] not specifically granted in this Agreement. `;

  copyrightLicenseAgreement.Payment_Of_Royalty =
    `${_receiver} will pay to ${_owner} a royalty which shall be calculated as follows: ` +
    `[Insert Detail of Royalty Payment. With each royalty payment, ` +
    `${_receiver} will submit to ${_owner} a written report that sets forth the calculation of the amount of the royalty payment.`;

  copyrightLicenseAgreement.Modifications =
    `Unless the prior written approval of ${_owner} is obtained, ${_receiver} may not modify or change the [Insert Shortname of Copyright Being Licensed] in any manner. ` +
    `The licensee shall not use Licensed property for any purpose that is unlawful or prohibited by these Terms of the Agreement. `;

  copyrightLicenseAgreement.Deafults =
    `If ${_receiver} fails to abide by the obligations of this Agreement, including the obligation to make a royalty payment when due, ` +
    `${_owner} shall have the option to cancel this Agreement by providing 30 days written notice to ${_receiver}. ` +
    `${_receiver} shall have the option of preventing the termination of this Agreement by taking corrective action that cures the default, ` +
    `if such corrective action is taken prior to the end of the time period stated in the previous sentence, and if there are no other defaults during such time period.`;

  copyrightLicenseAgreement.Arbitration =
    `All disputes under this Agreement that cannot be resolved by the parties shall be submitted to arbitration under the rules and regulations of the American Arbitration Association. ` +
    `Either party may invoke this paragraph after providing 30 days of written notice to the other party. All costs of arbitration shall be divided equally between the parties. ` +
    `Any award rendered by the arbitrator shall be final and binding on the parties and may be enforced by a court of law.`;

  copyrightLicenseAgreement.Warranties =
    `Neither party makes any warranties with respect to the use, sale, or other transfer of the [Insert Shortname of Copyright Being Licensed] by the other party or by any third party, ` +
    `and ${_receiver} accepts the product “AS IS.” In no event will ${_owner} be liable for direct, indirect, special, incidental, ` +
    `or consequential damages, that are in any way related to the [Insert Shortname of Copyright Being Licensed].`;

  copyrightLicenseAgreement.Transfer_Of_Rights =
    `This Agreement shall be binding on any successors of the parties. ` +
    `Neither party shall have the right to assign its interests in this Agreement to any other party unless the prior written consent of the other party is obtained. `;

  copyrightLicenseAgreement.Indemnification =
    `Each party shall indemnify and hold the other harmless for any losses, ` +
    `claims, damages, awards, penalties, or injuries incurred by any third party, ` +
    `including reasonable attorney’s fees, which arise from any alleged breach of such indemnifying party’s representations and warranties made under this Agreement, ` +
    `provided that the indemnifying party is promptly notified of any such claims. ` +
    `The indemnifying party shall have the sole right to defend such claims at its own expense. ` +
    `The other party shall provide, at the indemnifying party’s expense, such assistance in investigating and defending such claims as the indemnifying party may reasonably request. ` +
    `This indemnity shall survive the termination of this Agreement.`;

  copyrightLicenseAgreement.Termination =
    `This Agreement may be terminated by either party by providing 30 days written notice to the other party. ` +
    `This Agreement shall terminate automatically on ${copyrightLicenseAgreement.Termination_Date}. ` +
    `Upon termination or expiration of this Agreement, the Licensee shall cease reproducing, advertising, marketing, and distributing the Work as soon as is commercially feasible. ` +
    `Notwithstanding the foregoing, Licensee shall have the right to fill existing orders and to sell off existing copies of the Work then in stock. ` +
    `The copyright owner shall have the right to verify the existence and validity of the existing orders and existing copies of the Work then in stock upon reasonable notice to the Licensee. ` +
    `Termination or expiration of this Agreement shall not extinguish any of the Licensee’s or Copyright Owner’s obligations under this Agreement including, ` +
    `but not limited to, the obligation to pay royalties which by their terms continue after the date of termination or expiration. `;

  copyrightLicenseAgreement.Entire_Agreement =
    `This Agreement contains the entire agreement of the parties and there are no other promises or conditions in any other agreement whether oral or written. ` +
    `This Agreement supersedes any prior written or oral agreements between the parties.`;

  copyrightLicenseAgreement.Amendment = `This Agreement may be modified or amended if the amendment is made in writing and is signed by both parties.`;

  copyrightLicenseAgreement.Severability =
    `If any provision of this Agreement shall be held to be invalid or unenforceable for any reason, the remaining provisions shall continue to be valid and enforceable. ` +
    `If a court finds that any provision of this Agreement is invalid or unenforceable, but that by limiting such provision it would become valid or enforceable, ` +
    `then such provision shall be deemed to be written, construed, and enforced as so limited.`;

  copyrightLicenseAgreement.Notice =
    `The address of each party hereto as set forth at the beginning of this Agreement shall be the appropriate address for the mailing of notices, checks, and statements, if any. ` +
    `All notices shall be sent certified or registered mail and shall not be deemed received or effective unless and until actually received. Either party may change their mailing address by written notice to the other.` +
    `WAIVER OF CONTRACTUAL RIGHT; ` +
    +`The failure of either party to enforce any provision of this Agreement shall not be construed as a waiver or limitation of that party’s right to subsequently enforce and compel strict compliance with every provision of this Agreement.`;

  copyrightLicenseAgreement.Applicable_Law = `This Agreement shall be governed by the laws of the State of N/A.`;

  copyrightLicenseAgreement.Signatories = `This Agreement shall be signed on behalf of ${_owner} and on behalf of ${_receiver} and effective as of the date first above written.`;

  return copyrightLicenseAgreement;
};
